export default __webpack_public_path__ + "static/media/img-campaign.cad9fa4a.jpg";